import React, { memo } from "react";

const Select = ({ options, className, value, changeHandler, ...rest }) => {
    const onChangeHandler = e => {
        changeHandler(
            typeof Number(e.target.value) === "number"
                ? +e.target.value
                : e.target.value
        );
    };
    return (
        <select
            {...rest}
            className={`p-2 bg-transparent relative w-full  border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color ${className}`}
            value={value}
            onChange={onChangeHandler}
        >
            {options.map(item => (
                <option key={item.id} value={item.value}>
                    {item?.title || item.value}
                </option>
            ))}
        </select>
    );
};

export default memo(Select);
